module.exports = __webpack_public_path__ + "img/two.28cc6185.png";